module.exports = __webpack_public_path__ + "img/ao.d9500873.svg";